<template>
  <div id="init-home-container" class="mt-3 d-flex" style="width: 100%">
    <!--//@*/*
    //    *RPD  App v0.91
    //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
    //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
    //    */
    //-->

    <!-- <auth></auth> -->

    <v-spacer></v-spacer>
    <v-main>
      <v-container
        class="cmpbk black--text"
        id="home-container"
        style="max-width: 768px"
      >
        <!-- <img src="../images/winterbelive.jpg" /> -->
        <v-img
          contain
          lazy-src="../images/winterbelive_768.jpg"
          max-width="768"
          src="../images/winterbelive_768.jpg"
        ></v-img>

        <v-card elevation="2" shaped>
          <v-card-title
            ><h2 style="font-size: 1.5rem; word-break: break-word">
              Reno Police Department Facility Dog Request
            </h2></v-card-title
          >
          <v-card-text>
            <h4 style="font-size: 1rem">
              Use this form to request Winter, our Facility Dog.
            </h4>
          </v-card-text>
        </v-card>

        <template>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-card elevation="2" shaped class="mt-4">
              <v-card-text>
                <v-text-field
                  v-model="formIn.name"
                  maxlength="120"
                  :counter="120"
                  :rules="nameRules"
                  label="Name"
                  required
                ></v-text-field>
              </v-card-text>
            </v-card>

            <v-card elevation="2" shaped class="mt-4">
              <v-card-text>
                <v-text-field
                  maxlength="120"
                  :counter="120"
                  v-model="formIn.email"
                  :rules="emailRules"
                  label="E-mail"
                  required
                ></v-text-field>
              </v-card-text>
            </v-card>

            <!-- use -->
            <v-card elevation="2" shaped class="mt-4">
              <v-card-text>
                <v-select
                  dense
                  v-model="formIn.use"
                  :items="select_items"
                  label="Requested Use"
                ></v-select>
              </v-card-text>
            </v-card>

            <v-card elevation="2" shaped class="mt-4">
              <v-card-text>
                <v-text-field
                  :rules="requiredRules"
                  maxlength="60"
                  v-model="formIn.org"
                  label="Requester Agency or Organization"
                  :counter="60"
                ></v-text-field>
              </v-card-text>
            </v-card>

            <v-card elevation="2" shaped class="mt-4">
              <v-card-text>
                <v-text-field
                  maxlength="12"
                  v-model="formIn.phone"
                  label="Requester Phone number"
                  :rules="teleRule"
                  :counter="12"
                  hint="###-###-####"
                ></v-text-field>
              </v-card-text>
            </v-card>

            <!-- dates -->
            <v-card elevation="2" shaped class="mt-4">
              <v-card-text>
                <v-container>
                  <div class="mb-4">Dates</div>
                  <v-layout row align-center wrap>
                    <!-- date start -->
                    <v-flex xs12 sm6 md6 v-if="endDatePop_show == false">
                      <div class="d-flex justify-start">
                        <v-text-field
                          :readonly="startDatePop_show"
                          style="width: 70%"
                          maxlength="10"
                          v-model="formIn.startDate"
                          label="Start Date"
                          :rules="requiredRules"
                          :counter="10"
                          hint="##/##/####"
                        ></v-text-field>

                        <v-btn
                          v-if="startDatePop_show == false"
                          @click.prevent="statDatePop_shownow"
                          style="position: relative; top: 30px"
                          x-small
                          color="accent2"
                          class="mr-6 ml-2"
                        >
                          <v-icon color="white" center> $plus </v-icon>
                        </v-btn>
                      </div>
                    </v-flex>
                    <v-flex
                      xs12
                      sm12
                      md12
                      class="mt-4"
                      id="statDatePop"
                      v-if="startDatePop_show"
                    >
                      <template>
                        <div class="d-flex align-center justify-center">
                          <v-date-picker elevation="2" v-model="picker_start">
                            <template v-slot:default>
                              <v-btn
                                color="primary"
                                dark
                                @click="close_pickers()"
                              >
                                Close
                              </v-btn>
                            </template>
                          </v-date-picker>
                        </div>
                      </template>
                    </v-flex>
                    <v-flex xs12 sm6 md6 v-if="startDatePop_show == false">
                      <div class="d-flex justify-start">
                        <v-text-field
                          :readonly="endDatePop_show"
                          style="width: 95%"
                          maxlength="10"
                          v-model="formIn.endDate"
                          label="End Date"
                          :rules="requiredRules"
                          :counter="10"
                          hint="##/##/####"
                        ></v-text-field>

                        <v-btn
                          v-if="endDatePop_show == false"
                          @click.prevent="endDatePop_shownow"
                          style="position: relative; top: 30px"
                          x-small
                          color="accent2"
                          class="mr-6 ml-2"
                        >
                          <v-icon color="white" center> $plus </v-icon>
                        </v-btn>
                      </div>
                    </v-flex>

                    <v-flex
                      xs12
                      sm12
                      md12
                      class="mt-4"
                      id="startTimePop"
                      v-if="endDatePop_show"
                    >
                      <template>
                        <div class="d-flex align-center justify-center">
                          <v-date-picker elevation="2" v-model="picker_end">
                            <template v-slot:default>
                              <v-btn
                                color="primary"
                                dark
                                @click="close_pickers()"
                              >
                                Close
                              </v-btn>
                            </template></v-date-picker
                          >
                        </div>
                      </template>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
            </v-card>
            <!-- TIMEs -->

            <v-card elevation="2" shaped class="mt-4">
              <v-card-text>
                <v-container>
                  <div class="mb-4">Times</div>
                  <v-layout row align-center wrap>
                    <v-flex xs12 sm6 md6 v-if="endTimePop_show == false">
                      <div class="d-flex justify-start">
                        <v-flex xs6 sm6 md6>
                          <v-text-field
                            :readonly="startTimePop_show"
                            style="width: 95%"
                            maxlength="8"
                            v-model="formIn.time_start"
                            label="Start Time"
                            :rules="requiredRules"
                            :counter="8"
                            hint="##:## AM"
                          ></v-text-field>
                        </v-flex>
                        <v-btn
                          v-if="startTimePop_show == false"
                          @click.prevent="startTimePop_show = true"
                          style="position: relative; top: 30px"
                          x-small
                          color="accent2"
                          class="mr-6 ml-2"
                        >
                          <v-icon color="white" center> $plus </v-icon>
                        </v-btn>
                      </div>
                    </v-flex>

                    <v-flex
                      xs12
                      sm12
                      md12
                      class="mt-4"
                      id="endDatePop"
                      v-if="startTimePop_show"
                    >
                      <template>
                        <div class="d-flex align-center justify-center">
                          <v-time-picker
                            format="ampm"
                            landscape
                            no-title
                            elevation="5"
                            v-model="tm_picker_start"
                          >
                            <template v-slot:default>
                              <div
                                style="width: 100%"
                                class="d-flex justify-space-between"
                              >
                                <v-btn
                                  color="primary"
                                  dark
                                  @click="close_pickers()"
                                >
                                  Close
                                </v-btn>
                                <v-btn
                                  color="primary"
                                  dark
                                  @click="reset_starttime()"
                                >
                                  Reset
                                </v-btn>
                              </div>
                            </template>
                          </v-time-picker>
                        </div>
                      </template>
                    </v-flex>
                    <!-- end time -->
                    <v-flex xs12 sm6 md6 v-if="startTimePop_show == false">
                      <div class="d-flex justify-start">
                        <v-flex xs6 sm6 md6>
                          <v-text-field
                            :readonly="endTimePop_show"
                            style="width: 95%"
                            maxlength="8"
                            v-model="formIn.time_end"
                            label="End Time"
                            :rules="requiredRules"
                            :counter="8"
                            hint="##:## AM"
                          ></v-text-field>
                        </v-flex>
                        <v-btn
                          v-if="endTimePop_show == false"
                          @click.prevent="endTimePop_show = true"
                          style="position: relative; top: 30px"
                          x-small
                          color="accent2"
                          class="mr-6 ml-2"
                        >
                          <v-icon color="white" center> $plus </v-icon>
                        </v-btn>
                      </div>
                    </v-flex>

                    <v-flex
                      xs12
                      sm12
                      md12
                      class="mt-4"
                      id="endTimePop"
                      v-if="endTimePop_show"
                    >
                      <template>
                        <div class="d-flex align-center justify-center">
                          <v-time-picker
                            format="ampm"
                            landscape
                            no-title
                            elevation="5"
                            v-model="tm_picker_end"
                          >
                            <template v-slot:default>
                              <div
                                style="width: 100%"
                                class="d-flex justify-space-between"
                              >
                                <v-btn
                                  color="primary"
                                  dark
                                  @click="close_pickers()"
                                >
                                  Close
                                </v-btn>
                                <v-btn
                                  color="primary"
                                  dark
                                  @click="reset_endtime()"
                                >
                                  Reset
                                </v-btn>
                              </div>
                            </template>
                          </v-time-picker>
                        </div>
                      </template>
                    </v-flex>
                    <!-- <v-flex xs6 sm6 md6>
                      <v-text-field
                        style="width: 95%"
                        maxlength="8"
                        v-model="formIn.time_end"
                        label="End Time"
                        :rules="requiredRules"
                        :counter="8"
                        hint="##:## AM"
                      ></v-text-field>
                    </v-flex> -->
                  </v-layout>
                </v-container>
              </v-card-text>
            </v-card>

            <v-card elevation="2" shaped class="mt-4">
              <v-card-text>
                <v-textarea
                  outlined
                  required
                  :rules="requiredRules"
                  maxlength="2000"
                  :counter="2000"
                  name="decsr"
                  label="Brief Description"
                  v-model="formIn.descr"
                ></v-textarea>
              </v-card-text>
              <v-card-actions class="mt-4">
                <v-btn
                  :disabled="!valid"
                  color="success"
                  class="mr-4"
                  @click="validate"
                >
                  Submit Form For Review
                </v-btn>
              </v-card-actions>
            </v-card>

            <!-- <v-checkbox
              v-model="checkbox"
              :rules="[(v) => !!v || 'You must agree to continue!']"
              label="Do you agree?"
              required
            ></v-checkbox> -->
          </v-form>
        </template>
      </v-container>
    </v-main>
    <v-spacer></v-spacer>
  </div>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";

/* 0 media q */

@media (min-width: 0px) {
  #home-container {
    width: 100vw;
    max-width: 100vw;
    height: auto;
  }

  .results .v-expansion-panel-content::v-deep .v-expansion-panel-content__wrap,
  .recent .v-expansion-panel-content::v-deep .v-expansion-panel-content__wrap {
    padding: 0 7px !important;
  }

  .alice {
    color: aliceblue;
  }
}

/* 768 media q *
@media (min-width: 768px) {
}

/* 1025 media q */
@media (min-width: 1025px) {
}

/* 2048 media q */
@media (min-width: 2048px) {
}
</style>

<script>
/* eslint-disable */
import { bus_common } from "../mixins/bus_common";
// import xtabs from "./xtabs.vue";
// import auth from "./auth.vue";
//import addedit_diag from "./addedit_diag.vue";
// const add_edit = () => import("./add_edit.vue");
// const search = () => import("./search.vue");
// const searchResults = () => import("./searchResults.vue");
// const recent = () => import("./recent.vue");
// const DatePicker = () => import("./DatePicker.vue");
export default {
  name: "Home",
  components: {},
  mixins: [bus_common],
  props: {
    date: "",
  },
  data() {
    // Status, Fname, Lnprivateame, DOB, DIVISION
    return {
      // new_formIn: {
      //   descr: "IN the begining there was this turtle...",
      //   time_start: "11:10 AM",
      //   time_end: "1:55 PM",
      //   name: "JLM",
      //   email: "gzantmolt@gmail.com",
      //   use: "Other Interview",
      //   org: "BCS",
      //   phone: "777-777-7777",
      //   startDate: this.formatDate(new Date().toISOString().substr(0, 10)),
      //   endDate: this.formatDate(new Date().toISOString().substr(0, 10)),
      // },
      endTimePop_show: false,
      startTimePop_show: false,
      endDatePop_show: false,
      startDatePop_show: false,
      picker_start: this.newISODate(),
      picker_end: this.newISODate(),
      tm_picker_start: "",
      tm_picker_end: "",
      new_formIn: {
        descr: "",
        time_start: "",
        time_end: "",
        name: "",
        email: "",
        use: "",
        org: "",
        phone: "",
        startDate: this.formatDate(new Date().toISOString().substr(0, 10)),
        endDate: this.formatDate(new Date().toISOString().substr(0, 10)),
      },
      // new_formIn: {
      //   descr: "This is the decription from Molt's workstation",
      //   time_start: "12:12",
      //   time_end: "06:11",
      //   name: "Molt, Emailtest",
      //   email: "gzantmolt@gmail.com",
      //   use: "Peer Support",
      //   org: "BCS LLC",
      //   phone: "777-777-7777",
      //   startDate: this.formatDate(new Date().toISOString().substr(0, 10)),
      //   endDate: this.formatDate(new Date().toISOString().substr(0, 10)),
      // },
      formIn: {
        descr: "",
        time_start: "",
        time_end: "",
        name: "",
        email: "",
        use: "",
        org: "",
        phone: "",
        startDate: this.formatDate(new Date().toISOString().substr(0, 10)),
        endDate: this.formatDate(new Date().toISOString().substr(0, 10)),
      },
      valid: true,
      menu1: false,
      teleRule: [
        (v) => !!v || "Phone is required",
        (v) =>
          /^([0-9\\-])*$/.test(String(v)) ||
          "Phone must be a valid phone number`",
      ],
      nameRules: [
        (v) => !!v || "Name is required",
        (v) => (v && v.length <= 120) || "Name must be less than 10 characters",
      ],
      requiredRules: [(v) => !!v || "Field is required"],
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
      ],
      select: null,
      select_items: [
        "Forensic Interview",
        "Other Interview",
        "Client Meeting",
        "Court Use/Trial Use",
        "Peer Support",
        "Planned Field Response/Support",
        "Suspect Interviews",
        "Community Events",
        "Other",
      ],
      checkbox: false,
    };
  },
  watch: {
    // "$store.state.user": function () {
    //   //keep this
    //   let self = this;
    //   this.init();
    // },
    tm_picker_end() {
      this.formIn.time_end = this.convert2ampm_time(this.tm_picker_end);
    },
    tm_picker_start() {
      this.formIn.time_start = this.convert2ampm_time(this.tm_picker_start);
    },

    picker_start() {
      this.formIn.startDate = this.formatDate(this.picker_start);
      this.startDatePop_show = false;
    },
    picker_end() {
      this.formIn.endDate = this.formatDate(this.picker_end);
      this.endDatePop_show = false;
    },
  },
  methods: {
    /* sendRequest(rowData) {
      console.log(rowData);
    }, */

    message1() {
      alert("This button does nothing yet.");
    },
    reset_endtime() {
      this.endTimePop_show = false;
      this.tm_picker_end = "00:00";
      var self = this;
      this.$nextTick(() => {
        self.endTimePop_show = true;
      });
    },
    reset_starttime() {
      this.startTimePop_show = false;
      this.tm_picker_start = "00:00";
      var self = this;
      this.$nextTick(() => {
        self.startTimePop_show = true;
      });
    },
    close_pickers(dismissFn) {
      // console.log("do something before dismiss");
      // dismissFn();
      this.startDatePop_show = false;
      this.endDatePop_show = false;
      this.startTimePop_show = false;
      this.endTimePop_show = false;
    },

    newISODate() {
      var s_dt = new Date().toISOString();
      return s_dt.substring(0, s_dt.length - s_dt.indexOf("T") - 4);
    },
    endDatePop_shownow() {
      this.endDatePop_show = true;
    },
    statDatePop_shownow() {
      this.startDatePop_show = true;
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");

      return `${month}/${day}/${year}`;
    },
    formatDateIso(date) {
      if (!date) return null;

      const [month, day, year] = date.split("/");

      return `${year}-${month}-${day}`;
    },

    validate() {
      let callback = () => {
        window.location.replace("https://winterreq.renopd.com/");
      };
      if (this.$refs.form.validate() == true) {
        var formIn = this.mno(this.formIn);
        formIn.startDate = this.formatDateIso(formIn.startDate);
        formIn.endDate = this.formatDateIso(formIn.endDate);

        if (this.date_is_valid(formIn.startDate) == false) {
          this.swall_it(
            "Validation Status",
            "Start Date Invalid.",
            "warning",
            null,
            null
          );
          return true;
        }
        if (this.date_is_valid(formIn.endDate) == false) {
          this.swall_it(
            "Validation Status",
            "End Date Invalid.",
            "warning",
            null,
            null
          );
          return true;
        }

        if (this.date_before(formIn.startDate, formIn.endDate) === false) {
          this.swall_it(
            "Validation Status",
            "Start Date must proceed End Date or be the same.",
            "warning",
            null,
            null
          );
          return true;
        }

        //validate time
        if (this.time_is_valid(this.formIn.time_start) === false) {
          this.swall_it(
            "Validation Status",
            "Check Start Time.",
            "warning",
            null,
            null
          );
          return true;
        }
        if (this.time_is_valid(this.formIn.time_end) === false) {
          this.swall_it(
            "Validation Status",
            "Check End Time.",
            "warning",
            null,
            null
          );
          return true;
        }

        //if (
        //  this.time_before(this.formIn.time_start, this.formIn.time_end) ===
        //  false
        //) {
        //  this.swall_it(
        //    "Validation Status",
        //    "Start Time must be before End time.",
        //    "warning",
        //    null,
        //    null
        //  );
        //  return true;
        //}
          this.show_loader(true);
        //    formIn.email = this.$store.state.user.email;
        this.formIn.token = this.$store.state.user.token;

        formIn.apiname = "save_form";
        var self = this;
        this.$store
          .dispatch("anyapi", formIn)
          .then((data) => {
            // this.swall_it(
            //   "Save Status",
            //   "Saved. You will be contacted by email for more details. Thanks.",
            //   "sucess",
            //   null,
            //   null
            // );
              this.show_loader(false);
            this.$swal({
              title: "Save Status",
              text: "Saved. You will be contacted by email for more details. Thanks.",
              icon: "sucess",
              confirmButtonText: "OK",
              confirmButtonColor: "#283593",
              timer: 3000,
              didClose: callback,
            });
          })
          .catch((msg) => {
            self.dialog = false;
            this.show_loader(false);
            this.swall_it("Error", msg, "error", null, null);
          });
      } else {
        this.$swal({
          title: "Form Has Errors ",
          text: "Please correct the fields with the red text before submitting.",
          icon: "warning",
        });
      }
    },
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    init(self) {
      this.formIn = this.mno(this.new_formIn);
      this.show_loader(false);
    },
  },
  mounted() {
    var self = this;
    this.$nextTick(() => {
      this.init(self);
    });
  },
};
</script>
